import styles from './ThemeToggle.module.less';
import { Icon } from '../../shared/Icon/Icon';
import { useThemeStore } from '../../../stores/themeStore';

const ThemeToggle = ({ themes }: { themes: string; isMenu?: boolean }) => {
  const { toggleTheme, theme } = useThemeStore();

  return (
    <div
      onClick={toggleTheme}
      className={`${styles.themeToggle}  ${themes !== 'light' && styles.themeToggle__dark}`}
    >
      <Icon
        id="moon"
        className={`${styles.icon} ${themes !== 'light' && styles.iconLight} ${
          theme === 'light' && styles.iconActive
        }`}
      />
    </div>
  );
};

export default ThemeToggle;
